// The prep routes (worker/src/prepdoc.ts), all operator only. Typed wrappers
// over api(); an ApiError carries the status, so a caller can tell a missing
// prep (404) from a lost connection (0).

import type { PrepChatReply, PrepChatTurn, PrepDoc, PrepLayout, PrepListRow } from "@breeze/core";
import { api } from "./api";

export interface PrepSave {
  readonly slug: string;
  /** Section id to its new html. */
  readonly sections?: Readonly<Record<string, string>>;
  readonly layout?: PrepLayout;
}

export function listPreps(signal?: AbortSignal): Promise<PrepListRow[]> {
  return api<{ preps: PrepListRow[] }>("/api/prep/list", { signal }).then((r) => r.preps);
}

export function getPrepDoc(slug: string, signal?: AbortSignal): Promise<PrepDoc> {
  return api<PrepDoc>(`/api/prep/doc?slug=${encodeURIComponent(slug)}`, { signal });
}

export function savePrepDoc(save: PrepSave, opts: { keepalive?: boolean } = {}): Promise<PrepDoc> {
  return api<PrepDoc>("/api/prep/doc", { method: "POST", body: save, keepalive: opts.keepalive });
}

export function newPrep(body: { title: string; startsAt?: string; sections?: Record<string, string> }): Promise<PrepDoc> {
  return api<PrepDoc>("/api/prep/new", { method: "POST", body });
}

export function chatPrep(body: { slug?: string; messages: readonly PrepChatTurn[]; live?: string }, signal?: AbortSignal): Promise<PrepChatReply> {
  return api<PrepChatReply>("/api/prep/chat", { method: "POST", body, signal });
}

/** The host's goals (one "- " line each) and an opening question, written from the prep. */
export function prepGoals(slug: string, signal?: AbortSignal): Promise<{ goal: string; opener: string }> {
  return api<{ goal: string; opener: string }>(`/api/prep/goals?slug=${encodeURIComponent(slug)}`, { signal });
}
